var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviousButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "rotate(-180 28 28)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.2813 38.2187C28 38.4687 27.7344 38.4687 27.4844 38.2187L17.6875 28.375C17.4063 28.125 17.4063 27.875 17.6875 27.625L27.4844 17.7812C27.7344 17.5312 28 17.5312 28.2813 17.7812L29.2188 18.7187C29.3125 18.8125 29.3594 18.9375 29.3594 19.0937C29.3594 19.25 29.3125 19.3906 29.2188 19.5156L21.9531 26.7812L37.9375 26.7812C38.3125 26.7812 38.5 26.9687 38.5 27.3437L38.5 28.6562C38.5 29.0312 38.3125 29.2187 37.9375 29.2187L21.9531 29.2187L29.2188 36.4844C29.4688 36.7656 29.4688 37.0312 29.2188 37.2812L28.2813 38.2187Z",
    fill: "#9CA5B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousButton);
export default __webpack_public_path__ + "static/media/Previous_button.9faba6145e5c987d4260f1883c5b9988.svg";
export { ForwardRef as ReactComponent };